"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fetchApi;

var _constants = require("../constants");

var queryString = require("query-string");
function checkResponseStatusCode(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    var error = new Error(response.statusText);
    error.response = response; // decorate the error with the full server response.
    throw error;
}
function autoTimeout(ms, promise) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            var error = new Error("autoTimeout after " + ms + "ms");
            error.response = {
                status: _constants.FETCH_STATUS_TIMEOUT // decorate the error with a statusCode for the timeout
            };
            reject(error);
        }, ms);
        promise.then(resolve, reject);
    });
}
// parameters are exactly the same like the original fetch function
// see https://github.com/github/fetch
// will automatically timeout and throw errors on non 200 status codes
function fetchApi(url, options) {
    var queryMap = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    var query = queryString.stringify(queryMap);
    var requestUrl = query.length > 0 ? url + "?" + query : url;
    console.info("request", requestUrl, options);
    return autoTimeout(_constants.FETCH_TIMEOUT_MS, fetch(requestUrl, options)).then(checkResponseStatusCode).then(function (response) {
        console.info("response", requestUrl, response);
        return response;
    });
    // don't catch errors here, the actual action should always handle them!
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/fetchApi.ts
 ** module id = 1311
 ** module chunks = 0
 **/